export enum EmployeeStatus {
  Employee = 'Employee',
  Evaluation = 'Evaluation',
  Dismissed = 'Dismissed',
  Registered = 'Registered',
  Freelancer = 'Freelancer',
}
